// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3Iwjg","tab":"Tabs_tab__1PNRZ","tabActive":"Tabs_tabActive__21TzT"};